import React from "react";
import Pagination from "@mui/material/Pagination";

const PaginationComponent = ({ totalPages, currentPage, setCurrentPage }) => {
  const handleChange = (event, value) => {
    setCurrentPage(value);
  };
  return (
    <>
      <style>{`
        .MuiPagination-ul li .Mui-selected {
          background: transparent linear-gradient(0deg, #06AD60 0%, #00526E 100%) 0% 0% no-repeat padding-box;
            color: var(--white-color) !important;
            font-size:16px !important;
            min-width: 28px !important;
            height: 28px !important;
            font-family:"Poppins-semiBold" !important;
        }
        .MuiPagination-ul li button {
            color: var(--dashboard-text-color) !important;
            font-size:16px !important;
            font-family:"Poppins-semiBold" !important;
        }
    `}</style>
      <div>
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handleChange}
          shape="rounded"
        />
      </div>
    </>
  );
};

export default PaginationComponent;
